import { render, staticRenderFns } from "./App-block-card.vue?vue&type=template&id=f33b0d4c&scoped=true&"
import script from "./App-block-card.vue?vue&type=script&lang=ts&"
export * from "./App-block-card.vue?vue&type=script&lang=ts&"
import style0 from "./App-block-card.vue?vue&type=style&index=0&id=f33b0d4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33b0d4c",
  null
  
)

export default component.exports